import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

function FlexRow ({ itemSpacing, className, children }) {
  const classes = classNames({
    'l-flex-row': true,
    [`l-flex-row--item-spacing-${itemSpacing}`]: !!itemSpacing,
    [className]: className
  })

  return <div className={classes}>{children}</div>
}

FlexRow.propTypes = {
  itemSpacing: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xxl']),
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default FlexRow
